import React, { useEffect, useState } from "react";
import { addNewProduct, getCategories } from "../../configs/productsConfig";
import { useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";



function AdminNewProduct() {

    const navigate = useNavigate();
    const [option, setOption] = useState({
        option: '1',
        price: '',
        stock: '',
        weight: '',
        unitType: 'piece'
    })
    const [categories, setCategories] = useState([]);
    const [productData, setProductData] = useState({
        tableName: 'finished_products',
        name: '',
        price: [],
        stock: [],
        unitType: [],
        weight: [],
        categoryId: '',
        description: '',
        images: [],
        productOptions: [],
        guide: null,
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getCategories(productData.tableName);
                setCategories(data);
            } catch (error) {
                console.error(error);
            }
        };
        fetchData()
    }, [productData.tableName]);

    const saveNewProduct = async (productData, page) => {
        const res = await addNewProduct(productData);
        if (res.success) {
            navigate(`/products/${page}`);
        };
    };

    const handleImageChange = (e) => {
        const selectedFiles = Array.from(e.target.files);

        if (selectedFiles.length + productData.images.length > 4) {
            toast.error("Maximum 4 képet tudsz feltölteni.");
            return;
        }

        const newImages = selectedFiles.map((file) => ({
            file, // Tárold a fájl objektumot
            url: URL.createObjectURL(file), // Generálj blob URL-t
            name: file.name,
            type: file.type,
        }));

        setProductData((prevData) => ({
            ...prevData,
            images: [...prevData.images, ...newImages]
        }));

    };

    const handleDelete = (indexToDelete) => {
        const newImages = productData.images.filter((_, index) => index !== indexToDelete);
        setProductData((prevData) => ({ ...prevData, images: [...newImages] }));
    };

    const deleteProductOption = (indexToDelete) => {
        const newProductOptions = productData.productOptions.filter((_, index) => index !== indexToDelete);
        const newProductPrices = productData.price.filter((_, index) => index !== indexToDelete);
        const newProductStock = productData.stock.filter((_, index) => index !== indexToDelete);
        const newProductUnitType = productData.unitType.filter((_, index) => index !== indexToDelete);
        const newProductWeight = productData.weight.filter((_, index) => index !== indexToDelete);
        setProductData((prevData) => ({ ...prevData, productOptions: [...newProductOptions] }));
        setProductData((prevData) => ({ ...prevData, price: [...newProductPrices] }));
        setProductData((prevData) => ({ ...prevData, stock: [...newProductStock] }));
        setProductData((prevData) => ({ ...prevData, unitType: [...newProductUnitType] }));
        setProductData((prevData) => ({ ...prevData, weight: [...newProductWeight] }));
    };

    const handleAddOption = (option) => {
        const requiredFields = ['option', 'stock', 'price', 'weight', 'unitType'];
        const isEmpty = requiredFields.some(key => option[key] === '');

        if (isEmpty) {
            toast.error('Tölts ki minden mezőt!');
            return;
        }

        setProductData((prevData) => ({
            ...prevData,
            productOptions: [...prevData.productOptions, option.option],
            stock: [...prevData.stock, option.stock],
            price: [...prevData.price, option.price],
            weight: [...prevData.weight, option.weight],
            unitType: [...prevData.unitType, option.unitType]
        }));
        setOption({ option: '1', price: '', stock: '', weight: '', unitType: 'piece' });
    };

    return (
        <div className="container-fluid p-0">

            <div className="container-lg mt-4">

                <div className="d-flex flex-row justify-content-center mb-4">
                    <input className="form-check-input" type="checkbox" value="finished_products" onChange={(e) => setProductData((prevData) => ({
                        ...prevData,
                        tableName: e.target.value,
                    }))} checked={productData.tableName === "finished_products"} id="finishedProducts"></input>
                    <label className="form-check-label me-5 ms-2" htmlFor="finishedProducts">
                        Kész termék
                    </label>

                    <input className="form-check-input" type="checkbox" value="prepared_materials" onChange={(e) => setProductData((prevData) => ({
                        ...prevData,
                        tableName: e.target.value,
                    }))} checked={productData.tableName === "prepared_materials"} id="preparedMaterials"></input>
                    <label className="form-check-label ms-2 me-5" htmlFor="preparedMaterials">
                        Csináld magad
                    </label>

                    <input className="form-check-input" type="checkbox" value="materials" onChange={(e) => setProductData((prevData) => ({
                        ...prevData,
                        tableName: e.target.value,
                    }))} checked={productData.tableName === "materials"} id="materials"></input>
                    <label className="form-check-label ms-2" htmlFor="materials">
                        Alapanyag
                    </label>
                </div>

                <div className="d-flex flex-column justify-content-center align-items-center">

                    <div className="form-floating mb-3 col-lg-6 col-10">
                        <input type="text" className="form-control" id="productName" placeholder="" value={productData.name}
                            onChange={(e) =>
                                setProductData((prevData) => ({
                                    ...prevData,
                                    name: e.target.value,
                                }))
                            } required />
                        <label htmlFor="productName">Termék neve</label>
                    </div>

                    <div className="form-floating mb-3 col-lg-6 col-10">
                        <select className="form-select" id="category" aria-label="Kategória" value={productData.categoryId}
                            onChange={(e) =>
                                setProductData((prevData) => ({
                                    ...prevData,
                                    categoryId: e.target.value,
                                }))}>
                            <option value="">Válassz egy kategóriát</option>

                            {
                                categories.map(category => (
                                    <option value={category.id} key={category.id}>{category.category_name}</option>
                                ))
                            }

                        </select>
                        <label htmlFor="category">Kategória</label>
                    </div>

                    <div className="form-floating pb-3 mb-2 col-lg-6 col-10 border-bottom">
                        <textarea className="form-control h-100" placeholder="Termék leírása" id="productDescription" maxLength={1000} rows={15} value={productData.description}
                            onChange={(e) =>
                                setProductData((prevData) => ({
                                    ...prevData,
                                    description: e.target.value,
                                }))} required></textarea>
                        <label htmlFor="productDescription">Termék leírása</label>
                    </div>

                    <div className="col-lg-6 col-10 border-bottom">
                        <p className="m-0">Ha nincsenek termék opciók, 1-et kell írni az opció helyére.</p>
                        <div className="form-floating mb-3">
                            <input type="text" className="form-control" id="productOption" placeholder="" required value={option.option} onChange={(e)=>setOption((prevData)=>({
                                ...prevData,
                                option: e.target.value
                            }))}/>
                            <label htmlFor="productOption">Termék opció</label>
                        </div>

                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="productPrice" placeholder="" required value={option.price} onChange={(e)=>setOption((prevData)=>({
                                ...prevData,
                                price: e.target.value
                            }))}/>
                            <label htmlFor="productPrice">Termék ára</label>
                        </div>

                        <div className="form-floating mb-3">
                            <input type="number" className="form-control" id="productWeight" placeholder="" required value={option.weight} onChange={(e)=>setOption((prevData)=>({
                                ...prevData,
                                weight: e.target.value
                            }))}/>
                            <label htmlFor="productWeight">Termék súlya</label>
                        </div>

                        <div className="d-flex flex-sm-row flex-column align-items-center justify-content-center col-12 mb-3">
                            <div className="form-floating col-sm-4 me-2">
                                <input type="number" className="form-control" id="productStock" placeholder=""  required value={option.stock} onChange={(e)=>setOption((prevData)=>({
                                ...prevData,
                                stock: e.target.value
                            }))}/>
                                <label htmlFor="productStock">Elérhető készlet</label>
                            </div>
                            <div>
                                <input className="form-check-input" type="checkbox" value="piece" onChange={(e) => setOption((prevData) => ({
                                    ...prevData,
                                    unitType: e.target.value,
                                }))} checked={option.unitType === "piece"} id="unitPiece"></input>
                                <label className="form-check-label me-5 ms-2" htmlFor="unitPiece">
                                    Darab
                                </label>
                            </div>
                            <div>
                                <input className="form-check-input" type="checkbox" value="package" onChange={(e) => setOption((prevData) => ({
                                    ...prevData,
                                    unitType: e.target.value,
                                }))} checked={option.unitType === "package"} id="unitPackage"></input>
                                <label className="form-check-label me-5 ms-2" htmlFor="unitPackage">
                                    Csomag
                                </label>
                            </div>
                        </div>
                     
                    </div>
                    <button className="btn btn-home-primary col-sm-5 col-12  my-3" onClick={() => handleAddOption(option)}>Termék variáció létrehozása</button>
                </div>

            </div>

            <div className={`container-lg mb-3 ${productData.tableName === 'prepared_materials' ? '' : 'd-none'} d-flex flex-column align-items-center`}>
                <div className="col-lg-6">
                    <h5>Útmutató feltöltés:</h5>
                    <input type="file" name="guide"
                        accept="application/pdf"
                        onChange={(e) => {
                            const pdfFile = e.target.files[0];
                            setProductData((prevData) => ({
                                ...prevData,
                                guide: pdfFile,
                            }));
                        }} />
                </div>
            </div>

            <div className="container-lg d-flex flex-column align-items-center mb-3">
                <div className="col-lg-6">
                    <h5>Képfeltöltés:</h5>
                    <input type="file" className="uploadImageInput" multiple onChange={handleImageChange} />

                    <div>
                        {productData.images.map((image, index) => (
                            <div key={index} className="d-inline-block position-relative m-2">
                                <img src={image.url} alt={`Uploaded image ${index + 1}`} style={{ width: "150px" }} />
                                <button
                                    onClick={() => handleDelete(index)}
                                    className="btn p-1 rounded-0 position-absolute top-0 end-0 text-white bg-primary"
                                >
                                    X
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="container-lg col-md-7 table-responsive">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Opció</th>
                            <th>Ár</th>
                            <th>Készlet</th>
                            <th>Súly</th>
                            <th>Mennyiség típus</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                        {productData.productOptions.map((option, index) => (
                            <tr key={index}>
                                <td scope="row">
                                    <button className="btn" onClick={()=>deleteProductOption(index)}>X</button>
                                </td>
                                <td>{option}</td>
                                <td>{productData.price[index]} Ft</td>
                                <td>{productData.stock[index]} db</td>
                                <td>{productData.weight[index]} kg</td>
                                <td>{productData.unitType[index] === 'piece' ? 'Darab' : 'Csomag'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            

            <div className="container-lg mt-4 d-flex align-items-center justify-content-center">
                <button className="btn btn-primary col-md-2 col-6 mb-4" onClick={() => saveNewProduct(productData, productData.tableName)}>Mentés</button>
            </div>



        </div>
    );
}

export default AdminNewProduct;
